export const POST_PROJECT_IMAGE_REQUESTED = 'POST_PROJECT_IMAGE_REQUESTED';
export const POST_ATTACHMENT_REQUESTED = 'POST_ATTACHMENT_REQUESTED';
export const POST_ATTACHMENT_SUCCEEDED = 'POST_ATTACHMENT_SUCCEEDED';
export const GET_ATTACHMENTS_REQUESTED = 'GET_ATTACHMENTS_REQUESTED';
export const GET_ATTACHMENTS_SUCCEEDED = 'GET_ATTACHMENTS_SUCCEEDED';
export const GET_MEDIAFILES_REQUESTED = 'GET_MEDIAFILES_REQUESTED';
export const GET_MEDIAFILES_SUCCEEDED = 'GET_MEDIAFILES_SUCCEEDED';
